<ng-container *ngIf="cardType === 'coupon'">
    <ng-container *ngIf="!isBehaviourOrContinuityCoupon(data)">
        <button *ngIf="data.status === 'U'" type="button" class="btn btn-md btn-primary w-100 p-0 couponBtn-size" [attr.aria-describedby]="
          'coupon-price-' +
          data.offerId +
          ' ' +
          'coupon-title-' +
          data.offerId +
          ' ' +
          'coupon-description-' +
          data.offerId
        "
        [attr.aria-label]="clipCouponBtnLabel" 
        (click)="clipCoupon(data, $event)" id="couponAddBtn{{ data.offerId }}">
            {{
            data?.deleted
            ? behavioralOfferAttrs &&
            behavioralOfferAttrs?.addToMyListBtnText
            ? behavioralOfferAttrs?.addToMyListBtnText
            : "Add to List"
            : "Clip Coupon"
            }}
        </button>
        <div *ngIf="data.status === 'C' && !data?.deleted">
            <div class="clipped" role="status" aria-live="polite" [attr.aria-describedby]="
            'coupon-price-' +
            data.offerId +
            ' ' +
            'coupon-title-' +
            data.offerId +
            ' ' +
            'coupon-description-' +
            data.offerId
          ">
                <span class="clipped__checkmark svg-checkmark" aria-hidden="true"></span>
                <span class="clipped__label"><span class="sr-only">Coupon has already been </span>Clipped</span>
            </div>
        </div>
        <button  *ngIf="data.status === 'C' && data?.deleted" type="button" class="btn btn-md btn-primary w-100 p-0 couponBtn-size" [attr.aria-describedby]="
          'coupon-price-' +
          data.offerId +
          ' ' +
          'coupon-title-' +
          data.offerId +
          ' ' +
          'coupon-description-' +
          data.offerId
        " 
        [attr.aria-label]="clipCouponBtnLabel" 
        (click)="clipCoupon(data, $event)" id="couponAddBtn{{ data.offerId }}">
            {{
            data?.deleted
            ? behavioralOfferAttrs &&
            behavioralOfferAttrs?.addToMyListBtnText
            ? behavioralOfferAttrs?.addToMyListBtnText
            : "Add to List"
            : "Clip Coupon"
            }}
        </button>
    </ng-container>
    <ng-container *ngIf="isBehaviourOrContinuityCoupon(data)">
        <ng-container *ngIf="!isCouponClipped">
            <button type="button" class="btn btn-md btn-primary w-100 p-0 couponBtn-size" [attr.aria-describedby]="'coupon-price-' +
            data.offerId +
            ' ' +
            'coupon-title-' +
            data.offerId +
            ' ' +
            'coupon-description-' +
            data.offerId
          " 
          [attr.aria-label]="addToMyListBtnLabel"
          (click)="clipCoupon(data, $event)" id="couponAddBtn{{ data.offerId }}">{{
            data?.deleted
            ? behavioralOfferAttrs &&
            behavioralOfferAttrs?.addToMyListBtnText
            ? behavioralOfferAttrs?.addToMyListBtnText
            : "Add to List"
            : startChallengeLabel
            }}</button>
        </ng-container>
        <ng-container *ngIf="isCouponClipped">
            <ng-container *ngIf="!isBonusPathCompleted">
                <ng-container *ngIf="isContinuityCoupon">
                    <div class="d-flex flex-column">
                        <div role="progressbar" class="progress-offer-status">
                            <span class="progress-msg">{{
                                offerDataDisplay(data?.continuity).prefix
                                }}:&nbsp;</span>
                            <span class="pgs-lwrlmt">{{
                                offerDataDisplay(data?.continuity).progressVal
                                }}&nbsp;</span>
                            <span class="limit-separator">/&nbsp;</span>
                            <span class="pgs-uprlmt">{{
                                offerDataDisplay(data?.continuity).targetVal
                                }}&nbsp;</span>
                        </div>
                        <div class="progress" style="height: 6px;">
                            <div class="progress-bar" role="progressbar" [style]="getStyle(data)" attr.aria-valuenow="{{ data?.continuity.progressValue }}" aria-valuemin="0" attr.aria-valuemax="{{ data?.continuity.targetValue }}"></div>
                        </div>
                        <span *ngIf="isFreshpassContinuityCoupon(data)"
                            class="behaviour-link body-text-xs ">
                            <a role="link" href={{behavioralOfferAttrs.startShoppingLink}}
                                class="links__action links__action__inline underline"
                                (click)="navigateTo(behavioralOfferAttrs.startShoppingLink)"
                                (keydown.enter)="navigateTo(behavioralOfferAttrs.startShoppingLink)">{{behavioralOfferAttrs.startShoppingText}}</a>
                        </span>
                    </div>
                </ng-container>
                <ng-container *ngIf="isBehaviorCoupon">
                    <div class="progress-behaviour-status d-flex flex-column">
                        <span class="body-text-xs">{{ behavioralOfferAttrs?.inProgressStatusText }}</span>
                        <span class="behaviour-link-container">
                            <span class="behaviour-link body-text-xs">
                                <a class="links__action links__action__inline underline" *ngIf="
                                        data?.qualificationBehavior.trim().toLowerCase() ===
                                        behavioralOfferAttrs?.grClipTextOMS.trim().toLowerCase()
                                    " (click)="navigateTo(behavioralOfferAttrs.grClipLink)"
                                    (keydown.enter)="navigateTo(behavioralOfferAttrs.grClipLink)" role="link"
                                    href={{behavioralOfferAttrs.grClipLink}}>{{ behavioralOfferAttrs?.grClipButtonText
                                    }}</a>
                                <a class="links__action links__action__inline underline" *ngIf="
                                        data?.qualificationBehavior.trim().toLowerCase() ===
                                        behavioralOfferAttrs?.ucaEmailOptInTextOMS.trim().toLowerCase()
                                    " (click)="navigateTo(behavioralOfferAttrs.ucaEmailOptInLink)"
                                    (keydown.enter)="navigateTo(behavioralOfferAttrs.ucaEmailOptInLink)" role="link"
                                    href={{behavioralOfferAttrs.ucaEmailOptInLink}}>{{
                                    behavioralOfferAttrs?.ucaEmailOptInButtonText }}</a>
                                <a class="links__action links__action__inline underline" *ngIf="
                                        data?.qualificationBehavior.trim().toLowerCase() === behavioralOfferAttrs?.ecomFulfillmentTextOMS.trim().toLowerCase()
                                    " (click)="navigateTo(behavioralOfferAttrs.ecomFulfillmentLink)"
                                    (keydown.enter)="navigateTo(behavioralOfferAttrs.ecomFulfillmentLink)" role="link"
                                    href={{behavioralOfferAttrs.ecomFulfillmentLink}}>{{
                                    behavioralOfferAttrs?.ecomFulfillmentButtonText }}</a>
                            </span>
                        </span>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="isBonusPathCompleted">
                <div role="contentinfo" class="challenge-info">
                    <span [attr.aria-describedby]="challengeCompletedLabel">
                        <svg width="16px" height="16px" class="svg-icon svg-icon-coupon-carousel-tick-mark"
                            aria-hidden="true" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Symbols" stroke-width="1" fill-rule="evenodd">
                                <g id="Icons-/-Universal-/-Check-/-Gray" attr.fill="{{ challengeCompletedLabelColor }}">
                                    <polygon id="GreenCheck"
                                        points="19.6926976 5 21.1720549 6.34592056 9.50596091 19.1686094 3 12.9800394 4.37842439 11.5309203 9.40273692 16.3101236">
                                    </polygon>
                                </g>
                            </g>
                        </svg>
                    </span>
                    <span class="status" [ngStyle]="{
                            color: challengeCompletedLabelColor,
                            fontSize: fontSize
                        }">{{ challengeCompletedLabel }}</span>
                </div>
                <div *ngIf="!isFreshpassContinuityCoupon(data)"
                    class="behaviour-link body-text-xs ml-2">
                    <a role="link" href={{behavioralOfferAttrs.myListLink}}
                        class="links__action links__action__inline underline"
                        (click)="navigateTo(behavioralOfferAttrs.myListLink)"
                        (keydown.enter)="navigateTo(behavioralOfferAttrs.myListLink)">{{behavioralOfferAttrs.viewInMyListText}}</a>
                </div>
                <div *ngIf="isFreshpassContinuityCoupon(data)"
                    class="behaviour-link body-text-xs ml-2">
                    <a role="link" href={{behavioralOfferAttrs.freshPassOfferLink}}
                        class="links__action links__action__inline underline"
                        (click)="navigateTo(behavioralOfferAttrs.freshPassOfferLink)"
                        (keydown.enter)="navigateTo(behavioralOfferAttrs.freshPassOfferLink)">{{behavioralOfferAttrs.freshPassOfferText}}</a>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-container>